const Home = () => import('@/views/home')

/* 登录 */
const Login = () => import('@/views/login')
/* 页面 */
/* 合同 */
const contract_list = () => import('@/views/contract/list')
const contract_add = () => import('@/views/contract/add')
const contract_order_list = () => import('@/views/contract/COList')

/* 订单 */
const order_list = () => import('@/views/contract/order/list')
// const order_plan_list = () => import('@/views/contract/order/plan_list')
const order_add = () => import('@/views/contract/order/add')
/* 外贸 */
const trade_list = () => import('@/views/contract/trade/list')

/*下单or发货*/
const order_deliver = () => import('@/views/contract/placeOrder/deliver/list')
const order_place = () => import('@/views/contract/placeOrder/list')
// const order_plan_list = () => import('@/views/contract/order/plan_list')
// const order_add = () => import('@/views/contract/order/add')

/* 财务 */
// const invoice = () => import('@/views/finance/invoice')
// const collections = () => import('@/views/finance/collections')
const finance_list = () => import('@/views/finance/list')
const CollectionVerification = () => import('@/views/finance/CollectionVerification/index')
const finance_refund_list = () => import('@/views/finance/refund/list')
const finance_invoice_list = () => import('@/views/finance/invoice/list')
const satistic_chart = () => import('@/views/finance/satistic/chart')
// const subordinate_satistic = () => import('@/views/satistic/subordinate')
// const board_satistic = () => import('@/views/satistic/board')

/* 售后 */
// const new_order = () => import('@/views/aftermarket/new_order')
const aftermarket_list = () => import('@/views/aftermarket/list')
const tradeParts_list = () => import('@/views/aftermarket/trade/list')
const statistics_list = () => import('@/views/statistics/index')



/* 型号选择 */
const machine_list = () => import('@/views/machine/list')
const machine_series = () => import('@/views/machine/series/list')
const machine_model = () => import('@/views/machine/model/list')

/* 设备编号 */
const equipment_list = () => import('@/views/equipment/list')
const transferOrder = () => import('@/views/equipment/transferOrder')


/* 设置 */
/* 用户管理 */
const user_list = () => import('@/views/system/user/list')
const customer_list = () => import('@/views/system/customer/list')
const saler_list = () => import('@/views/system/saler/list')
const bank_list = () => import('@/views/system/bank/list')
const file_list = () => import('@/views/system/file/upload')
const currency_list = () => import('@/views/system/currency/list')


/*研发的页面*/
const email_list = ()=>import('@/views/development/email/list')
const user_dev = ()=>import('@/views/development/user/list')
const download = ()=>import('@/views/development/email/Download')


let router = [
  {
    path: '/', // 默认地址
    // redirect: '/cdkey/add'
    redirect: '/home'
  },
  {
    path: '/login',
    component: Login,
    meta: {
      title: '登录',
      keepAlive: true, // 需要被缓存
      needLogin: false,
      permission: false
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    icon: "el-icon-house",
    meta: {
      title: '首页',
      keepAlive: true, // 需要被缓存
      needLogin: true,
      permission: false
    },
  },
/*  {
    path: '/contract_order_list',
    name: 'contract_order_list',
    component: contract_order_list,
    icon: "el-icon-notebook-1",
    meta: {
      title: '合同订单一览表',
      keepAlive: true, // 需要被缓存
      needLogin: true,

      permission: ['root', 'admin', 'contract', 'finance','tradeSale','afterSale','import','tradeBusiness','tradeBusiness1','afterSale2','afterSale3','Sale']
    },
  }, {
    path: '/contract',
    name: 'contract',
    component: {
      render: h => h('router-view')
    },
    redirect: '/contract/list',
    icon: "el-icon-folder-opened",
    meta: {
      title: '合同管理',
      permission: ['root', 'admin', 'contract','tradeBusiness','tradeBusiness1','import']
    },
    children: [
      {
        path: 'list',
        name: 'contract_list',
        component: contract_list,
        meta: {
          title: '合同列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract','tradeBusiness','tradeBusiness1','import']
        },
      },
      {
        path: 'add',
        name: 'contract_add',
        component: contract_add,
        meta: {
          title: '新增合同',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract','tradeBusiness','tradeBusiness1']
        },
      },
    ]
  },
  {
    path: '/order',
    name: 'order',
    component: {
      render: h => h('router-view')
    },
    redirect: '/order/list',
    icon: "el-icon-document-copy",
    meta: {
      title: '订单管理',
      permission: ['root', 'admin', 'contract','tradeBusiness','tradeBusiness1','import']
    },
    children: [
      {
        path: 'list',
        name: 'order_list',
        component: order_list,
        meta: {
          title: '订单列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract','tradeBusiness','tradeBusiness1','import']
        },
      },
      {
        path: 'add',
        name: 'order_add',
        component: order_add,
        meta: {
          title: '新增订单',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract','tradeBusiness','tradeBusiness1']
        },
      },
      {
        path: 'plan_list',
        name: 'order_plan_list',
        component: order_list,
        meta: {
          title: '备展订单',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract','tradeBusiness','tradeBusiness1','import']
        },
      },

    ]
  },

  {
    path: '/report',
    name: 'report',
    component: {
      render: h => h('router-view')
    },
    redirect: '/report/list',
    icon: "el-icon-document-copy",
    meta: {
      title: '日报管理',
      permission: ['root', 'admin','afterSale','afterSalesStaff0','afterSalesStaff3','afterSale2','tradeBusiness1','Sale','tradeSale']
    },
    children: [
      {
        path: 'list',
        name: 'report_list',
        component: report_list,
        meta: {
          title: '日报列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin','afterSale','afterSalesStaff0','afterSalesStaff3','afterSale2','tradeBusiness1','Sale','tradeSale']
        },
      },
      {
        path: 'WaitingSubmit',
        name: 'will_list',
        component: will_list,
        meta: {
          title: '待提交列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin','afterSale','afterSalesStaff0','afterSalesStaff3']
        },
      },
      {
        path: 'submitStatus',
        name: 'submit_status',
        component: submit_status,
        meta: {
          title: '提交情况',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin','afterSale','afterSalesStaff0','afterSalesStaff3']
        },
      },
      {
        path: 'user_list',
        name: 'UserList',
        component: report_user_list,
        meta: {
          title: '用户列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin','afterSalesStaff0']
        },
      },

    ]
  },


  {
    path: '/placeOrder',
    name: 'placeOrder',
    component: {
      render: h => h('router-view')
    },
    redirect: '/list',
    icon: "el-icon-shopping-cart-full",
    meta: {
      title: '下单发货',
      permission: ['root','tradeBusiness','tradeBusiness1','tradeSale','finance']
    },
    children: [
      {
        path: 'list',
        name: 'PlaceOrder',
        component: order_place,
        meta: {
          title: '下单列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root','tradeBusiness','tradeBusiness1','tradeSale']
        },
      },
      {
        path: 'deliver/list',
        name: 'Deliver',
        component: order_deliver,
        meta: {
          title: '发货列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root','tradeBusiness','tradeBusiness1','tradeSale','finance']
        },
      }
    ]
  },
  {
    path: '/trade',
    name: 'trade',
    component: {
      render: h => h('router-view')
    },
    redirect: '/trade/list',
    icon: "el-icon-data-board",
    meta: {
      title: '外贸管理',
      permission: ['root', 'admin','tradeBusiness','tradeBusiness1','finance']
    },
    children: [
      {
        path: 'list',
        name: 'trade_list',
        component: trade_list,
        meta: {
          title: '台账列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin','tradeBusiness','tradeBusiness1','finance']
        },
      },

      {
        path: '@/views/aftermarket/trade/list',
        name: 'tradeParts_list',
        component: tradeParts_list,
        meta: {
          title: '配件订单',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin','tradeBusiness','tradeBusiness1','finance']
        },
      },


      {
        path: '@/views/statistics/list',
        name: 'list',
        component: statistics_list,
        meta: {
          title: '报表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root','tradeBusiness','tradeBusiness1']
        },
      },
    ]
  },
  // {
  //   path: '/equipment',
  //   name: 'equipment',
  //   component: {
  //     render: h => h('router-view')
  //   },
  //   redirect: '/equipment/list',
  //   icon: "el-icon-cpu",
  //   meta: {
  //     title: '设备编号管理',
  //     permission: ['root', 'admin', 'contract', 'hfPlan', 'szPlan', 'xRay', 'colorSelect', 'securityCheck', 'weightCheck', 'metalCheck']
  //   },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'equipment_list',
  //       component: equipment_list,
  //       meta: {
  //         title: '列表',
  //         keepAlive: true, // 需要被缓存
  //         needLogin: true,
  //         permission: ['root', 'admin', 'hfPlan', 'szPlan', 'xRay', 'colorSelect', 'securityCheck', 'weightCheck', 'metalCheck']
  //       },
  //     },
  //     {
  //       path: 'transferOrder',
  //       name: 'transferOrder',
  //       component: transferOrder,
  //       meta: {
  //         title: '转单',
  //         keepAlive: true, // 需要被缓存
  //         needLogin: true,
  //         permission: ['root', 'admin', 'contract', 'xRay', 'colorSelect', 'securityCheck', 'weightCheck', 'metalCheck']
  //       },
  //     }
  //   ]
  // },
  {
    path: '/finance',
    name: 'finance',
    component: {
      render: h => h('router-view')
    },
    redirect: '/finance/list',
    icon: "el-icon-coordinate",
    meta: {
      title: '财务管理',
      permission: ['root', 'admin', 'contract', 'finance','afterSale','tradeSale'
        ,'tradeBusiness','tradeBusiness1','paymentRecord','afterSale2']
    },
    children: [
      {
        path: 'list',
        name: 'finance_list',
        component: finance_list,
        meta: {
          title: '收款记录',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract', 'finance','afterSale',
            'tradeSale','tradeBusiness','tradeBusiness1','paymentRecord','afterSale2']
        },
      },
      {
        path: 'collectionVerification/index',
        name: 'CollectionVerification',
        component: CollectionVerification,
        meta: {
          title: '收款核对',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract', 'finance','afterSale','afterSale2','tradeSale','tradeBusiness','tradeBusiness1']
        },
      },
      {
        path: 'refundList',
        name: 'finance_refund_list',
        component: finance_refund_list,
        meta: {
          title: '退款记录',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'finance']
        },
      },
      {
        path: 'invoiceList',
        name: 'finance_invoice_list',
        component: finance_invoice_list,
        meta: {
          title: '开票记录',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'finance','afterSale','afterSale2']
        },
      },
      {
        path: 'satistic/chart',
        name: 'satistic_chart',
        component: satistic_chart,
        meta: {
          title: '统计',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'finance']
        },
      },
    ]
  },
  {
    path: '/aftermarket',
    name: 'aftermarket',
    component: {
      render: h => h('router-view')
    },
    redirect: '/aftermarket',
    icon: "el-icon-headset",
    meta: {
      title: '售后管理',
      permission: ['root', 'admin', 'afterSale','afterSale2']
    },
    children: [
      {
        path: 'list',
        name: 'aftermarket_list',
        component: aftermarket_list,
        meta: {
          title: '内贸订单',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin','afterSale','afterSale2']
        },
      },
    ]
  },
  {
    path: '/development',
    name: 'development',
    component: {
      render: h => h('router-view')
    },
    redirect: '/development',
    icon: "el-icon-s-platform",
    meta: {
      title: '研发管理',
      permission: ['root', 'admin', 'development']
    },
    children: [
      {
        path: 'email/list',
        name: 'EmailList',
        component: email_list,
        meta: {
          title: '邮件记录',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'development']
        },
      },
      {
        path: 'development/user/list',
        name: 'user_dev',
        component: user_dev,
        meta: {
          title: '用户列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'development']
        },
      },
      {
        path: 'development/email/download',
        name: 'Download',
        component: download,
        meta: {
          title: '模板下载',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'development']
        },
      },
    ]
  },
  {
    path: '/CDKEY',
    name: 'CDKEY',
    component: {
      render: h => h('router-view')
    },
    redirect: '/CDKEY/list',
    icon: "el-icon-s-opportunity",
    meta: {
      title: '激活码管理',
      keepAlive: true, // 需要被缓存
      needLogin: true,
      permission: ['root', 'admin', 'finance', 'afterSale','afterSale2', 'warehouse', 'development','tradeBusiness1','techSupport','afterSalesStaff3','afterSale3','tech_support','product']
    },
    children: [
      {
        path: 'add',
        name: 'CDKEY_add',
        component: CDKEY_add,
        meta: {
          title: '激活码新增',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'finance', 'afterSale','afterSale2', 'warehouse', 'development','tradeBusiness1','techSupport','afterSalesStaff3','afterSale3','tech_support','product']
        },
      },
      {
        path: 'list',
        name: 'CDKEY_list',
        component: CDKEY_list,
        meta: {
          title: '激活码列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'finance', 'afterSale','afterSale2', 'warehouse', 'development','tradeBusiness1','techSupport','afterSale3','product']
        },
      },

      // {
      //   path: 'model/list',
      //   name: 'machine_model',
      //   component: machine_model,
      //   meta: {
      //     title: '型号列表',
      //     keepAlive: true, // 需要被缓存
      //     needLogin: true,
      //     permission:true
      //   },
      // },
    ]
  },
  // {
  //   path: '/machine',
  //   name: 'aftermarket',
  //   component: {
  //     render: h => h('router-view')
  //   },
  //   redirect: '/machine/list',
  //   icon: "el-icon-s-grid",
  //   meta: {
  //     title: '型号管理',
  //     permission: ['root', 'admin']
  //   },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'machine_list',
  //       component: machine_list,
  //       meta: {
  //         title: '配置',
  //         keepAlive: true, // 需要被缓存
  //         needLogin: true,
  //         permission: ['root', 'admin']
  //       },
  //     },
  //     {
  //       path: 'series/list',
  //       name: 'machine_series',
  //       component: machine_series,
  //       meta: {
  //         title: '系列列表',
  //         keepAlive: true, // 需要被缓存
  //         needLogin: true,
  //         permission: ['root', 'admin']
  //       },
  //     },
  //     // {
  //     //   path: 'model/list',
  //     //   name: 'machine_model',
  //     //   component: machine_model,
  //     //   meta: {
  //     //     title: '型号列表',
  //     //     keepAlive: true, // 需要被缓存
  //     //     needLogin: true,
  //     //     permission:true
  //     //   },
  //     // },
  //   ]
  // },
  {
    path: '/system',
    name: 'system',
    component: {
      render: h => h('router-view')
    },
    redirect: '/system/user/list',
    icon: "el-icon-user-solid",
    meta: {
      title: '系统管理',
      permission: ['root', 'admin', 'contract', 'finance','import','tradeBusiness','tradeBusiness1']
    },
    children: [
      {
        path: 'user/list',
        name: 'user_list',
        component: user_list,
        meta: {
          title: '用户列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin']
        },
      },
      {
        path: 'customer/list',
        name: 'customer_list',
        component: customer_list,
        meta: {
          title: '客户列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract']
        },
      },
      {
        path: 'saler/list',
        name: 'saler_list',
        component: saler_list,
        meta: {
          title: '销售列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract','tradeBusiness','tradeBusiness1']
        },
      },
      {
        path: 'bank/list',
        name: 'bank_list',
        component: bank_list,
        meta: {
          title: '银行列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'finance']
        },
      },

      {
        path: 'file/upload',
        name: 'file_list',
        component: file_list,
        meta: {
          title: '文件上传',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'finance','import']
        },
      },
      {
        path: 'currency/list',
        name: 'currency',
        component: currency_list,
        meta: {
          title: '汇率列表',
          keepAlive: true, // 需要被缓存
          needLogin: true,
          permission: ['root', 'admin', 'contract','finance']
        },
      },
    ]
  },*/
]
export default router;



// WEBPACK FOOTER //
// ./src/router/PC.js